export default {
  name: 'CodeCanyon',
  abbreviation: 'CC',
  domain: 'codecanyon.net',
  google_analytics_id: 'UA-11834194-12',
  google_remarketing_label: 'bdtlCM3-uQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. eCommerce plugin',
  filterOrder: [
    'category',
    'tags',
    'price',
    'discounted-only',
    'software-version',
    'compatible-with',
    'sales',
    'rating',
    'date-added',
    'date-updated'
  ],
  features: {}
}
